module.exports = __webpack_public_path__ + "img/font-little-title-2x.70c8c125.png";